import axios from 'axios';
import { getAuth } from "firebase/auth";
import { logger } from '../utils/logger';
import { baseAxiosConfig, applyVerticalOverrideInterceptor } from '../utils/apiConfig';

const revenueAxios = applyVerticalOverrideInterceptor(axios.create(baseAxiosConfig));

/**
 * Fetch stored revenue estimates from MongoDB for the user's vertical
 * @returns {Promise<Object>} Revenue estimates data with portfolio summary
 */
export async function getStoredRevenueEstimates() {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const token = await user.getIdToken();

    const response = await revenueAxios.get('/revenue/stored-estimates', {
      params: {
        user: user.email
      },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.data) {
      throw new Error('No data received from server');
    }

    return response.data;
  } catch (error) {
    logger.error("Error in getStoredRevenueEstimates:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

const revenueService = {
  getStoredRevenueEstimates
};

export default revenueService;
